const MonitorIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10C14 11.019 13.692 11.964 13.168 12.754L10.293 9.879C10.105 9.691 10 9.437 10 9.172V5.101C12.282 5.564 14 7.581 14 10ZM8 9.586V5.101C5.45 5.619 3.604 8.077 4.073 10.868C4.398 12.802 5.893 14.411 7.802 14.86C9.272 15.205 10.662 14.893 11.754 14.169L8.585 11C8.21 10.625 8 10.116 8 9.586ZM19 5H17C16.447 5 16 5.448 16 6C16 6.552 16.447 7 17 7H19C19.553 7 20 6.552 20 6C20 5.448 19.553 5 19 5ZM19 9H17C16.447 9 16 9.448 16 10C16 10.552 16.447 11 17 11H19C19.553 11 20 10.552 20 10C20 9.448 19.553 9 19 9ZM19 13H17C16.447 13 16 13.448 16 14C16 14.552 16.447 15 17 15H19C19.553 15 20 14.552 20 14C20 13.448 19.553 13 19 13ZM24 6V14C24 16.757 21.757 19 19 19H13V21H17C17.553 21 18 21.448 18 22C18 22.552 17.553 23 17 23H7C6.447 23 6 22.552 6 22C6 21.448 6.447 21 7 21H11V19H5C2.243 19 0 16.757 0 14V6C0 3.243 2.243 1 5 1H19C21.757 1 24 3.243 24 6ZM22 6C22 4.346 20.654 3 19 3H5C3.346 3 2 4.346 2 6V14C2 15.654 3.346 17 5 17H19C20.654 17 22 15.654 22 14V6Z"
        fill="#01486D"
      />
    </svg>
  );
};

export default MonitorIcon;
